import React from 'react';
import i18n from '../../i18n';

class PaymentCard extends React.Component {
  render() {
    const { icon: Icon, label, amount, className, onClick, interactive = false } = this.props;

    return (
      <div
        className={`payment-card ${className} ${interactive ? 'payment-card-interactive' : ''}`}
        onClick={onClick}
        style={interactive ? { cursor: 'pointer' } : {}}
      >
        <div className="payment-card-icon">
          <Icon size={20} />
        </div>
        <div className="payment-card-content">
          <span className="payment-card-label">{label}</span>
          <span className="payment-card-amount">
            {amount} <span className="currency">{i18n.t('omr')}</span>
          </span>
        </div>
      </div>
    );
  }
}

export default PaymentCard;
